const bonjoerMobileControllers = new WeakSet();

function bonjoerMobileSetup(root = document) {
  const mobile = window.matchMedia('(max-width: 749px)');
  root.querySelectorAll('[data-pstr-menu]').forEach((dialog) => {
    if (bonjoerMobileControllers.has(dialog)) return;
    bonjoerMobileControllers.add(dialog);
    dialog.addEventListener('click', (event) => {
      if (!mobile.matches) return;
      const link = event.target.closest('a[href]');
      if (link && dialog.open) dialog.close();
    });
  });
  root.querySelectorAll('.pstr-footer').forEach((footer) => {
    if (bonjoerMobileControllers.has(footer)) return;
    bonjoerMobileControllers.add(footer);
    footer.addEventListener('toggle', (event) => {
      if (!mobile.matches) return;
      const opened = event.target;
      if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;
      footer.querySelectorAll('.pstr-footer__menu[open]').forEach((item) => {
        if (item !== opened) item.removeAttribute('open');
      });
    }, true);
  });
}

document.addEventListener('DOMContentLoaded', () => bonjoerMobileSetup(), { once: true });
document.addEventListener('shopify:section:load', (event) => bonjoerMobileSetup(event.target));
bonjoerMobileSetup();

// Keep the compact option summary in sync with the native variant picker.
document.addEventListener('change', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
  const picker = input.closest('.pstr-option-picker');
  if (!picker) return;
  const selected = picker.querySelector('[data-pstr-selected-option]');
  if (selected) selected.textContent = input.value;
  picker.open = false;
});
